import Layout from "../../components/Layout";

const Support = () => {
  return (
    <Layout>
      <div>Support Page</div>
    </Layout>
  );
};

export default Support;
